module.exports = __webpack_public_path__ + "static/media/Ellen.d6edc801.png";